const dictionary = require('./dictionary');

const baseUrl = 'https://clink-assets.s3.eu-west-2.amazonaws.com';

const caretDownWhite = `${baseUrl}${dictionary.caretDownWhite}`;
const clinkImage = `${baseUrl}${dictionary.clinkImage}`;
const prosperImage = `${baseUrl}${dictionary.prosperImage}`;
const pegasusLogo = `${baseUrl}${dictionary.pegasusLogo}`;
const hatLogo = `${baseUrl}${dictionary.hatLogo}`;
const prosperPackagesDefault = `${baseUrl}${dictionary.prosperPackagesDefault}`;
const clinkLogo = `${baseUrl}${dictionary.clinkLogo}`;

const iconMessage = `${baseUrl}${dictionary.iconMessage}`;

const redCaretLeft = `${baseUrl}${dictionary.redCaretLeft}`;
const redCaretRight = `${baseUrl}${dictionary.redCaretRight}`;
const redCaretUp = `${baseUrl}${dictionary.redCaretUp}`;
const redCaretDown = `${baseUrl}${dictionary.redCaretDown}`;
const iconDownloadBlack = `${baseUrl}${dictionary.iconDownloadBlack}`;
const iconMessageBlack = `${baseUrl}${dictionary.iconMessageBlack}`;
const iconOrganiseBlack = `${baseUrl}${dictionary.iconOrganiseBlack}`;
const iconQuoteBlack = `${baseUrl}${dictionary.iconQuoteBlack}`;

const pegasusBlackLogo = `${baseUrl}${dictionary.pegasusBlackLogo}`;
const closeButtonActive = `${baseUrl}${dictionary.closeButtonActive}`;
const closeButtonDisabled = `${baseUrl}${dictionary.closeButtonDisabled}`;

const blackCarretRight = `${baseUrl}${dictionary.blackCarretRight}`;
const blackCarretDown = `${baseUrl}${dictionary.carretDown}`;
const blackCarretUp = `${baseUrl}${dictionary.carretUp}`;

const poundWhite = `${baseUrl}${dictionary.poundWhite}`;
const blackCarretLeft = `${baseUrl}${dictionary.blackCarretLeft}`;
const upload = `${baseUrl}${dictionary.upload}`;

const prosperLogoFull = `${baseUrl}${dictionary.prosperLogoFull}`;
const deleteIconRed = `${baseUrl}${dictionary.deleteIconRed}`;
// Editor icons
const chatCloseSvg = `${baseUrl}${dictionary.chatCloseSvg}`;
const attachSvg = `${baseUrl}${dictionary.attachSvg}`;
const boldSvg = `${baseUrl}${dictionary.boldSvg}`;
const italicSvg = `${baseUrl}${dictionary.italicSvg}`;
const orderedSvg = `${baseUrl}${dictionary.orderedSvg}`;
const underlineSvg = `${baseUrl}${dictionary.underlineSvg}`;
const unorderedSvg = `${baseUrl}${dictionary.unorderedSvg}`;
// Mobile Prosper

const iconConversationGray = `${baseUrl}${dictionary.iconConversationGray}`;
const iconSearchBlack = `${baseUrl}${dictionary.iconSearchBlack}`;
const iconAddWhite = `${baseUrl}${dictionary.iconAddWhite}`;
const addGray = `${baseUrl}${dictionary.addGray}`;
const iconCloseRed = `${baseUrl}${dictionary.iconCloseRed}`;
const iconHamburgerWhite = `${baseUrl}${dictionary.iconHamburgerWhite}`;
const iconPdfBlack = `${baseUrl}${dictionary.iconPdfBlack}`;

const iconArrowdownLightblue = `${baseUrl}${dictionary.iconArrowdownLightblue}`;
const iconBuildingLightblue = `${baseUrl}${dictionary.iconBuildingLightblue}`;
const iconChatLightblue = `${baseUrl}${dictionary.iconChatLightblue}`;
const iconListLightblue = `${baseUrl}${dictionary.iconListLightblue}`;

const instructions = `${baseUrl}${dictionary.instructions}`;
const ncr = `${baseUrl}${dictionary.ncr}`;
const pmp = `${baseUrl}${dictionary.pmp}`;
const project = `${baseUrl}${dictionary.project}`;
const carretDownGray = `${baseUrl}${dictionary.carretDownGray}`;
const expand = `${baseUrl}${dictionary.expand}`;
const tools = `${baseUrl}${dictionary.tools}`;
const forecast = `${baseUrl}${dictionary.forecast}`;

const forecastPurple = `${baseUrl}${dictionary.forecastPurple}`;
const instructionsPurple = `${baseUrl}${dictionary.instructionsPurple}`;
const pmpPurple = `${baseUrl}${dictionary.pmpPurple}`;
const projectPurple = `${baseUrl}${dictionary.projectPurple}`;
const toolsPurple = `${baseUrl}${dictionary.toolsPurple}`;
const ncrPurple = `${baseUrl}${dictionary.ncrPurple}`;

const locationLogo = `${baseUrl}${dictionary.locationLogo}`;
const infoLogo = `${baseUrl}${dictionary.infoLogo}`;
const infoLogoBlack = `${baseUrl}${dictionary.infoLogoBlack}`;
const infoLogoGray = `${baseUrl}${dictionary.infoLogoGray}`;
const infoLogoRed = `${baseUrl}${dictionary.infoLogoRed}`;
const rocketLogo = `${baseUrl}${dictionary.rocketLogo}`;
const calendarLogo = `${baseUrl}${dictionary.calendarLogo}`;
const statusLogo = `${baseUrl}${dictionary.statusLogo}`;
const closedIcon = `${baseUrl}${dictionary.closedIcon}`;

const iconContractor = `${baseUrl}${dictionary.iconContractor}`;
const checkmarkGreen = `${baseUrl}${dictionary.checkmarkGreen}`;
const iconSearchGreen = `${baseUrl}${dictionary.iconSearchGreen}`;
const pngIconGreen = `${baseUrl}${dictionary.pngIconGreen}`;

const alcumus = `${baseUrl}${dictionary.alcumus}`;
const chas = `${baseUrl}${dictionary.chas}`;
const considerate = `${baseUrl}${dictionary.considerate}`;
const constructiOnline = `${baseUrl}${dictionary.constructiOnline}`;
const iso14001 = `${baseUrl}${dictionary.iso14001}`;
const iso9001 = `${baseUrl}${dictionary.iso9001}`;
const ohas18001 = `${baseUrl}${dictionary.ohas18001}`;
const smas = `${baseUrl}${dictionary.smas}`;

const uploadFailedSvg = `${baseUrl}${dictionary.uploadFailedSvg}`;
const uploadingSvg = `${baseUrl}${dictionary.uploadingSvg}`;
const uploadSvg = `${baseUrl}${dictionary.uploadSvg}`;
const iconClinkLogo = `${baseUrl}${dictionary.iconClinkLogo}`;

const iconTokenEmptyBig = `${baseUrl}${dictionary.iconTokenEmptyBig}`;
const iconTokenEmptySmall = `${baseUrl}${dictionary.iconTokenEmptySmall}`;
const iconTokenSmall = `${baseUrl}${dictionary.iconTokenSmall}`;

const iconRoundCheckGreen = `${baseUrl}${dictionary.iconRoundCheckGreen}`;
const iconRoundCheckRedInverted = `${baseUrl}${dictionary.iconRoundCheckRedInverted}`;
const iconRoundCheckRed = `${baseUrl}${dictionary.iconRoundCheckRed}`;

// Prosper Success
const logoChecked = `${baseUrl}${dictionary.logoChecked}`;
const logoStripe = `${baseUrl}${dictionary.logoStripe}`;

const backgroundShapesInternal = `${baseUrl}${dictionary.backgroundShapesInternal}`;

const armConcepts = `${baseUrl}${dictionary.armConcepts}`;
const benmax = `${baseUrl}${dictionary.benmax}`;
const dorplan = `${baseUrl}${dictionary.dorplan}`;
const GKDrywall = `${baseUrl}${dictionary.GKDrywall}`;
const SLE = `${baseUrl}${dictionary.SLE}`;
const baseUFH = `${baseUrl}${dictionary.baseUFH}`;
const LBC = `${baseUrl}${dictionary.LBC}`;
const vepcons = `${baseUrl}${dictionary.vepcons}`;
const weatherfix = `${baseUrl}${dictionary.weatherfix}`;

const calendarGreen = `${baseUrl}${dictionary.calendarGreen}`;
const svgLightpurpleQuotes = `${baseUrl}${dictionary.svgLightpurpleQuotes}`;
const svgPurpleQuotes = `${baseUrl}${dictionary.svgPurpleQuotes}`;
const pngLightpurpleQuotes = `${baseUrl}${dictionary.pngLightpurpleQuotes}`;
const pngPurpleQuotes = `${baseUrl}${dictionary.pngPurpleQuotes}`;
const sosNext = `${baseUrl}${dictionary.sosNext}`;
const tenderReturnTemplate = `${baseUrl}${dictionary.tenderReturnTemplate}`;
const luke = `${baseUrl}${dictionary.luke}`;

const marker = `${baseUrl}${dictionary.marker}`;
const markerWarning = `${baseUrl}${dictionary.markerWarning}`;
const iconReturnBlack = `${baseUrl}${dictionary.iconReturnBlack}`;
const iconRecommendedOrange = `${baseUrl}${dictionary.iconRecommendedOrange}`;
const iconXBlack = `${baseUrl}${dictionary.iconXBlack}`;
const iconTrashBlack = `${baseUrl}${dictionary.iconTrashBlack}`;

const dateLine = `${baseUrl}${dictionary.dateLine}`;
const alertLine = `${baseUrl}${dictionary.alertLine}`;

const specialistLogo = `${baseUrl}${dictionary.specialistLogo}`;
const excelBlack = `${baseUrl}${dictionary.excelBlack}`;
const pdfBlack = `${baseUrl}${dictionary.pdfBlack}`;
const iconLinkBlack = `${baseUrl}${dictionary.iconLinkBlack}`;

// clink app package management
const iconDecisionCalendarPink = `${baseUrl}${dictionary.iconDecisionCalendarPink}`;
const iconDownArrowGrey = `${baseUrl}${dictionary.iconDownArrowGrey}`;
const iconCloseButtonCrossGrey = `${baseUrl}${dictionary.iconCloseButtonCrossGrey}`;
const iconDecisionCalendarGrey = `${baseUrl}${dictionary.iconDecisionCalendarGrey}`;
const iconAwardedGrey = `${baseUrl}${dictionary.iconAwardedGrey}`;

// C-LINK TIMELINE
const iconEditTurqoise = `${baseUrl}${dictionary.iconEditTurqoise}`;
const iconExclamationTriangleRed = `${baseUrl}${dictionary.iconExclamationTriangleRed}`;
const iconRoundAwardedLigthgreen = `${baseUrl}${dictionary.iconRoundAwardedLigthgreen}`;
const iconRoundEditLigthgreen = `${baseUrl}${dictionary.iconRoundEditLigthgreen}`;
const iconRoundOnsiteLigthgreen = `${baseUrl}${dictionary.iconRoundOnsiteLigthgreen}`;
const iconRoundQuotedLigthgreen = `${baseUrl}${dictionary.iconRoundQuotedLigthgreen}`;
const iconRoundTenderLigthgreen = `${baseUrl}${dictionary.iconRoundTenderLigthgreen}`;

// clink - prosper profile
const constructionLogo = `${baseUrl}${dictionary.constructionLogo}`;
const iconDownloadWhite = `${baseUrl}${dictionary.iconDownloadWhite}`;
const iconPersonWhite = `${baseUrl}${dictionary.iconPersonWhite}`;
const iconAssuranceGray = `${baseUrl}${dictionary.iconAssuranceGray}`;
const iconApprovedGreen = `${baseUrl}${dictionary.iconApprovedGreen}`;
const iconPoundGreen = `${baseUrl}${dictionary.iconPoundGreen}`;
const iconDownloadGray = `${baseUrl}${dictionary.iconDownloadGray}`;
const iconProvidedTeal = `${baseUrl}${dictionary.iconProvidedTeal}`;
const iconNotProvidedRed = `${baseUrl}${dictionary.iconNotProvidedRed}`;

// clink - prosper profile - tabs
const iconAccreditationsGray = `${baseUrl}${dictionary.iconAccreditationsGray}`;
const iconAccreditationsGreen = `${baseUrl}${dictionary.iconAccreditationsGreen}`;
const iconIncusrancesGray = `${baseUrl}${dictionary.iconIncusrancesGray}`;
const iconIncusrancesGreen = `${baseUrl}${dictionary.iconIncusrancesGreen}`;
const iconLocationsGray = `${baseUrl}${dictionary.iconLocationsGray}`;
const iconLocationsGreen = `${baseUrl}${dictionary.iconLocationsGreen}`;
const iconManagementGray = `${baseUrl}${dictionary.iconManagementGray}`;
const iconManagementGreen = `${baseUrl}${dictionary.iconManagementGreen}`;
const iconProjectGray = `${baseUrl}${dictionary.iconProjectGray}`;
const iconProjectGreen = `${baseUrl}${dictionary.iconProjectGreen}`;
const iconReferencesGray = `${baseUrl}${dictionary.iconReferencesGray}`;
const iconReferencesGreen = `${baseUrl}${dictionary.iconReferencesGreen}`;
const iconTradesGray = `${baseUrl}${dictionary.iconTradesGray}`;
const iconTradesGreen = `${baseUrl}${dictionary.iconTradesGreen}`;
const iconTurnoverGray = `${baseUrl}${dictionary.iconTurnoverGray}`;
const iconTurnoverGreen = `${baseUrl}${dictionary.iconTurnoverGreen}`;

// Prosper Status Icons
const iconBlackAccept = `${baseUrl}${dictionary.iconBlackAccept}`;
const iconBlackInterest = `${baseUrl}${dictionary.iconBlackInterest}`;
const iconBlackQuote = `${baseUrl}${dictionary.iconBlackQuote}`;
const iconBlackTender = `${baseUrl}${dictionary.iconBlackTender}`;
const iconBlackTrophy = `${baseUrl}${dictionary.iconBlackTrophy}`;
const iconWhiteAccept = `${baseUrl}${dictionary.iconWhiteAccept}`;
const iconWhiteInterest = `${baseUrl}${dictionary.iconWhiteInterest}`;
const iconWhiteQuote = `${baseUrl}${dictionary.iconWhiteQuote}`;
const iconWhiteTender = `${baseUrl}${dictionary.iconWhiteTender}`;
const iconWhiteTrophy = `${baseUrl}${dictionary.iconWhiteTrophy}`;
const iconRedDanger = `${baseUrl}${dictionary.iconRedDanger}`;
const iconRedAward = `${baseUrl}${dictionary.iconRedAward}`;

// Company profile
const iconPurpleDoc = `${baseUrl}${dictionary.iconPurpleDoc}`;
const iconPurpleWebsite = `${baseUrl}${dictionary.iconPurpleWebsite}`;
const iconPurplePhone = `${baseUrl}${dictionary.iconPurplePhone}`;
const iconPurpleMail = `${baseUrl}${dictionary.iconPurpleMail}`;
const iconPurpleLocation = `${baseUrl}${dictionary.iconPurpleLocation}`;
const iconPurpleLinkedin = `${baseUrl}${dictionary.iconPurpleLinkedin}`;

// Interests revamp

const iconOrangeCalendar = `${baseUrl}${dictionary.iconOrangeCalendar}`;
const iconOrangePound = `${baseUrl}${dictionary.iconOrangePound}`;
const iconOrangeStart = `${baseUrl}${dictionary.iconOrangeStart}`;
const iconOrangeType = `${baseUrl}${dictionary.iconOrangeType}`;
const iconRedClock = `${baseUrl}${dictionary.iconRedClock}`;
const iconWhiteLock = `${baseUrl}${dictionary.iconWhiteLock}`;
const registeredInterestIcon = `${baseUrl}${dictionary.registeredInterestIcon}`;
const distancePink = `${baseUrl}${dictionary.distancePink}`;
const distancePurple = `${baseUrl}${dictionary.distancePurple}`;

// Prosper Pro

const iconPartyHorn = `${baseUrl}${dictionary.iconPartyHorn}`;
const iconWhiteBell = `${baseUrl}${dictionary.iconWhiteBell}`;
const iconWhiteClock = `${baseUrl}${dictionary.iconWhiteClock}`;
const iconThumbnailBuildingsDesktop = `${baseUrl}${dictionary.iconThumbnailBuildingsDesktop}`;
const iconThumbnailBuildingsMobile = `${baseUrl}${dictionary.iconThumbnailBuildingsMobile}`;
const iconThumbnailBuildingsDesktopSp = `${baseUrl}${dictionary.iconThumbnailBuildingsDesktopSp}`;
const iconThumbnailWorkers = `${baseUrl}${dictionary.iconThumbnailWorkers}`;

// Prosper How To Work
const iconHowToWork = `${baseUrl}${dictionary.iconHowToWork}`;

const closeButton = `${baseUrl}${dictionary.closeButton}`;
const freeTokenAwarded = `${baseUrl}${dictionary.freeTokenAwarded}`;
const freeTokenAwardedBlank = `${baseUrl}${dictionary.freeTokenAwardedBlank}`;

// Prosper Preq v2
const iconReuseBlack = `${baseUrl}${dictionary.iconReuseBlack}`;
const iconTargetBlack = `${baseUrl}${dictionary.iconTargetBlack}`;
const iconRoundPoundBlack = `${baseUrl}${dictionary.iconRoundPoundBlack}`;
const iconBlackBin = `${baseUrl}${dictionary.iconBlackBin}`;
const iconApprovedWhite = `${baseUrl}${dictionary.iconApprovedWhite}`;
const iconCalendarBlack = `${baseUrl}${dictionary.iconCalendarBlack}`;
const iconCasketBlack = `${baseUrl}${dictionary.iconCasketBlack}`;
const iconCertificateGray = `${baseUrl}${dictionary.iconCertificateGray}`;
const iconEnvelopeBlack = `${baseUrl}${dictionary.iconEnvelopeBlack}`;
const iconEyeBlack = `${baseUrl}${dictionary.iconEyeBlack}`;
const iconFacebookBlack = `${baseUrl}${dictionary.iconFacebookBlack}`;
const iconCloseWhite = `${baseUrl}${dictionary.iconCloseWhite}`;
const iconHammerBlack = `${baseUrl}${dictionary.iconHammerBlack}`;
const iconInsuranceDarkgray = `${baseUrl}${dictionary.iconInsuranceDarkgray}`;
const iconPendingWhite = `${baseUrl}${dictionary.iconPendingWhite}`;
const iconQuestionBlack = `${baseUrl}${dictionary.iconQuestionBlack}`;
const iconRejectedWhite = `${baseUrl}${dictionary.iconRejectedWhite}`;
const iconRulerBlack = `${baseUrl}${dictionary.iconRulerBlack}`;
const iconSckrewBlack = `${baseUrl}${dictionary.iconSckrewBlack}`;
const iconShareFillBlack = `${baseUrl}${dictionary.iconShareFillBlack}`;
const iconThreeDotsBlack = `${baseUrl}${dictionary.iconThreeDotsBlack}`;
const iconWhatsappBlack = `${baseUrl}${dictionary.iconWhatsappBlack}`;
const viewProfileCarousel = `${baseUrl}${dictionary.viewProfileCarousel}`;
const iconCloseGray = `${baseUrl}${dictionary.iconCloseGray}`;
const requestIcon = `${baseUrl}${dictionary.requestIcon}`;

const customerHealthScore = `${baseUrl}${dictionary.customerHealthScore}`;

const soaChecked = `${baseUrl}${dictionary.soaChecked}`;
// clink BOQ
const boqScratch = `${baseUrl}${dictionary.boqScratch}`;

// Prosper Preq PQQ new documents
// Enviromental, Quality, Management System Procedures
const isoLogoRegisteredTrademarkOG = `${baseUrl}${dictionary.isoLogoRegisteredTrademarkOG}`;
const isoLogoRegisteredTrademark = `${baseUrl}${dictionary.isoLogoRegisteredTrademark}`;
// Enviromental
const fscLogoOG = `${baseUrl}${dictionary.fscLogoOG}`;
const fscLogo = `${baseUrl}${dictionary.fscLogo}`;
// Health, Safety & Environmental Qualifications
const ioshLogoOG = `${baseUrl}${dictionary.ioshLogoOG}`;
const ioshLogo = `${baseUrl}${dictionary.ioshLogo}`;
const neboshLogoOG = `${baseUrl}${dictionary.neboshLogoOG}`;
const neboshLogo = `${baseUrl}${dictionary.neboshLogo}`;
// Management System Procedures
const UKASManagemntSystemLogoOG = `${baseUrl}${dictionary.UKASManagemntSystemLogoOG}`;
const UKASManagemntSystemLogo = `${baseUrl}${dictionary.UKASManagemntSystemLogo}`;
// Acreditations
const ifcAccOG = `${baseUrl}${dictionary.ifcAccOG}`;
const ifcAcc = `${baseUrl}${dictionary.ifcAcc}`;
const asfpLogoOG = `${baseUrl}${dictionary.asfpLogoOG}`;
const asfpLogo = `${baseUrl}${dictionary.asfpLogo}`;
const firasOG = `${baseUrl}${dictionary.firasOG}`;
const firas = `${baseUrl}${dictionary.firas}`;
const ssipLogoOG = `${baseUrl}${dictionary.ssipLogoOG}`;
const ssipLogo = `${baseUrl}${dictionary.ssipLogo}`;

const sendQuoteBOQ = `${baseUrl}${dictionary.sendQuoteBOQ}`;

module.exports = {
  sendQuoteBOQ,
  isoLogoRegisteredTrademarkOG,
  isoLogoRegisteredTrademark,
  fscLogoOG,
  fscLogo,
  ioshLogoOG,
  ioshLogo,
  neboshLogoOG,
  neboshLogo,
  UKASManagemntSystemLogoOG,
  UKASManagemntSystemLogo,
  ifcAccOG,
  ifcAcc,
  asfpLogoOG,
  asfpLogo,
  firasOG,
  firas,
  ssipLogoOG,
  ssipLogo,
  requestIcon,
  iconCloseGray,
  viewProfileCarousel,
  iconOrangeCalendar,
  iconOrangePound,
  iconOrangeStart,
  iconOrangeType,
  iconRedClock,
  iconWhiteLock,
  registeredInterestIcon,
  iconEditTurqoise,
  iconExclamationTriangleRed,
  iconRoundAwardedLigthgreen,
  iconRoundEditLigthgreen,
  iconRoundOnsiteLigthgreen,
  iconRoundQuotedLigthgreen,
  iconRoundTenderLigthgreen,
  iconLinkBlack,
  marker,
  markerWarning,
  dateLine,
  alertLine,
  iconReturnBlack,
  calendarGreen,
  svgLightpurpleQuotes,
  svgPurpleQuotes,
  pngLightpurpleQuotes,
  pngPurpleQuotes,
  sosNext,
  tenderReturnTemplate,
  luke,
  armConcepts,
  benmax,
  dorplan,
  GKDrywall,
  SLE,
  baseUFH,
  LBC,
  vepcons,
  weatherfix,
  iconTokenEmptyBig,
  iconTokenEmptySmall,
  iconTokenSmall,
  iconClinkLogo,
  uploadSvg,
  uploadingSvg,
  uploadFailedSvg,
  dictionary,
  pngIconGreen,
  alcumus,
  clinkLogo,
  chas,
  considerate,
  constructiOnline,
  iso14001,
  iso9001,
  ohas18001,
  smas,
  chatCloseSvg,
  iconContractor,
  checkmarkGreen,
  iconSearchGreen,
  locationLogo,
  infoLogo,
  infoLogoBlack,
  infoLogoGray,
  infoLogoRed,
  rocketLogo,
  calendarLogo,
  statusLogo,
  closedIcon,
  prosperPackagesDefault,
  blackCarretUp,
  attachSvg,
  boldSvg,
  italicSvg,
  orderedSvg,
  underlineSvg,
  unorderedSvg,
  pegasusLogo,
  hatLogo,
  prosperImage,
  caretDownWhite,
  clinkImage,
  redCaretLeft,
  redCaretRight,
  redCaretUp,
  redCaretDown,
  iconDownloadBlack,
  iconMessageBlack,
  iconOrganiseBlack,
  iconQuoteBlack,
  iconMessage,
  pegasusBlackLogo,
  closeButtonActive,
  closeButtonDisabled,
  blackCarretRight,
  poundWhite,
  blackCarretDown,
  blackCarretLeft,
  upload,
  prosperLogoFull,
  deleteIconRed,
  iconConversationGray,
  iconSearchBlack,
  addGray,
  iconAddWhite,
  iconCloseRed,
  iconHamburgerWhite,
  iconPdfBlack,
  iconArrowdownLightblue,
  iconBuildingLightblue,
  iconChatLightblue,
  iconListLightblue,
  instructions,
  ncr,
  pmp,
  project,
  carretDownGray,
  expand,
  tools,
  forecast,
  logoChecked,
  logoStripe,
  forecastPurple,
  instructionsPurple,
  pmpPurple,
  projectPurple,
  toolsPurple,
  ncrPurple,
  iconRecommendedOrange,
  specialistLogo,
  excelBlack,
  pdfBlack,
  iconXBlack,
  iconTrashBlack,
  backgroundShapesInternal,
  iconBlackAccept,
  iconBlackInterest,
  iconBlackQuote,
  iconBlackTender,
  iconBlackTrophy,
  iconWhiteAccept,
  iconWhiteInterest,
  iconWhiteQuote,
  iconWhiteTender,
  iconWhiteTrophy,
  iconRedDanger,
  iconRedAward,
  iconPurpleDoc,
  iconPurpleWebsite,
  iconPurplePhone,
  iconPurpleMail,
  iconPurpleLocation,
  iconPurpleLinkedin,
  iconPartyHorn,
  iconWhiteBell,
  iconWhiteClock,
  iconThumbnailBuildingsDesktop,
  iconThumbnailBuildingsMobile,
  iconThumbnailBuildingsDesktopSp,
  iconThumbnailWorkers,
  closeButton,
  iconHowToWork,
  freeTokenAwarded,
  freeTokenAwardedBlank,
  distancePurple,
  distancePink,
  iconReuseBlack,
  iconTargetBlack,
  iconRoundPoundBlack,
  iconBlackBin,
  iconApprovedWhite,
  iconCalendarBlack,
  iconCasketBlack,
  iconCertificateGray,
  iconEnvelopeBlack,
  iconEyeBlack,
  iconFacebookBlack,
  iconCloseWhite,
  iconHammerBlack,
  iconInsuranceDarkgray,
  iconPendingWhite,
  iconQuestionBlack,
  iconRejectedWhite,
  iconRulerBlack,
  iconSckrewBlack,
  iconShareFillBlack,
  iconThreeDotsBlack,
  iconWhatsappBlack,
  constructionLogo,
  iconDownloadWhite,
  iconPersonWhite,
  iconAccreditationsGray,
  iconAccreditationsGreen,
  iconIncusrancesGray,
  iconIncusrancesGreen,
  iconLocationsGray,
  iconLocationsGreen,
  iconManagementGray,
  iconManagementGreen,
  iconProjectGray,
  iconProjectGreen,
  iconReferencesGray,
  iconReferencesGreen,
  iconTradesGray,
  iconTradesGreen,
  iconTurnoverGray,
  iconTurnoverGreen,
  iconAssuranceGray,
  iconApprovedGreen,
  iconProvidedTeal,
  iconNotProvidedRed,
  iconPoundGreen,
  iconDownloadGray,
  customerHealthScore,
  iconDecisionCalendarPink,
  iconDownArrowGrey,
  iconCloseButtonCrossGrey,
  iconDecisionCalendarGrey,
  iconAwardedGrey,
  soaChecked,
  boqScratch,
  iconRoundCheckGreen,
  iconRoundCheckRedInverted,
  iconRoundCheckRed,
};
